import { get } from 'lodash';
import * as CONSTANTS from '../../constants';

const initialState = {
  isLoading: false,
  error: null,
  list: {
    data: [],
    error: null,
  },
  getAvailableApisForApiGroups: {
    data: [],
  },
  createApiGroup: {
    data: null,
  },
  getApiGroup: {
    data: null,
  },
  deleteApiGroup: {
    data: null,
  },
  editApiGroup: {
    data: null,
  },
  apiGroupNameUnique: {
    data: null,
  },
  updateApisForApiGroups: {
    data: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.API_GROUPS_REQUEST:
      return {
        ...state,
        isLoading: true,
        list: {
          data: null,
          error: null,
        },
      };
    case CONSTANTS.API_GROUPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: {
          data: action.payload,
          error: null,
        },
      };
    case CONSTANTS.API_GROUPS_ERROR:
      return {
        ...state,
        isLoading: false,
        list: {
          error: action.payload,
          data: null,
        },
      };
    case CONSTANTS.GET_AVAILABLE_APIS_FOR_API_GROUPS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        getAvailableApisForApiGroups: {
          data: null,
        },
      };
    case CONSTANTS.GET_AVAILABLE_APIS_FOR_API_GROUPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        getAvailableApisForApiGroups: {
          data: action.payload,
        },
      };
    case CONSTANTS.GET_AVAILABLE_APIS_FOR_API_GROUPS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        getAvailableApisForApiGroups: {
          data: null,
        },
      };
    case CONSTANTS.CREATE_API_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        createApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.CREATE_API_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        createApiGroup: {
          data: action.payload,
        },
      };
    case CONSTANTS.CREATE_API_GROUP_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        createApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_SINGLE_API_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        getApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_SINGLE_API_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        getApiGroup: {
          data: action.payload,
        },
      };
    case CONSTANTS.FETCH_SINGLE_API_GROUP_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        getApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.EDIT_API_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        editApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.EDIT_API_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        editApiGroup: {
          data: action.payload,
        },
      };
    case CONSTANTS.EDIT_API_GROUP_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        editApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.DELETE_API_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        deleteApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.DELETE_API_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        deleteApiGroup: {
          data: action.payload,
        },
      };
    case CONSTANTS.DELETE_API_GROUP_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        deleteApiGroup: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_API_GROUP_NAME_UNIQUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        apiGroupNameUnique: {
          data: action.payload,
        },
      };
    case CONSTANTS.FETCH_API_GROUP_NAME_UNIQUE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        apiGroupNameUnique: {
          data: null,
        },
      };
    case CONSTANTS.UPDATE_APIS_FOR_API_GROUPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        updateApisForApiGroups: {
          data: action.payload,
        },
      };
    case CONSTANTS.UPDATE_APIS_FOR_API_GROUPS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        updateApisForApiGroups: {
          data: null,
        },
      };
    default:
      return state;
  }
}

export const getApiGroupsList = (state) => get(state, 'apiGroups.list.data');
export const getApiGroupsLoading = (state) => get(state, 'apiGroups.isLoading');
export const getApiGroupsError = (state) => get(state, 'apiGroups.list.error');
export const getAvailableApisTotalElementsForGroups = (state) => get(state, 'apiGroups.getAvailableApisForApiGroups.data.totalElements');
export const getAvailableApisTotalPagesForGroups = (state) => get(state, 'apiGroups.getAvailableApisForApiGroups.data.totalPages');
export const getAvailableApisForGroups = (state) => get(state, 'apiGroups.getAvailableApisForApiGroups.data.results');
export const getCreateApiGroup = (state) => get(state, 'apiGroups.createApiGroup.data');
export const getApiGroupAddEditDeleteErrors = (state) => get(state, 'apiGroups.error[0].error');
export const getSingleApiGroup = (state) => get(state, 'apiGroups.getApiGroup.data');
export const getEditApiGroup = (state) => get(state, 'apiGroups.editApiGroup.data');
export const getDeleteApiGroup = (state) => get(state, 'apiGroups.deleteApiGroup.data');
export const getApiGroupNameUnique = (state) => get(state, 'apiGroups.apiGroupNameUnique.data.d.result');
export const getUpdateApisForApiGroups = (state) => get(state, 'apiGroups.updateApisForApiGroups.data');
export const getUpdateApisForApiGroupsErrors = (state) => get(state, 'apiGroups.error[0].response.data.error.message.value');
